import { t } from '../../../../i18n.js';

/**
 * @param {string} type
 * @returns {HTMLElement}
 */
export function createUnsupportedBlock(type) {
  const el = document.createElement('div');
  el.className = 'ai-unsupported-block';
  el.setAttribute('role', 'note');

  const label = document.createElement('span');
  label.className = 'ai-unsupported-block__label';
  label.textContent = t('ai_unsupported_block');

  const typeEl = document.createElement('span');
  typeEl.className = 'ai-unsupported-block__type';
  typeEl.textContent = `type: ${type || '(missing)'}`;

  el.appendChild(label);
  el.appendChild(typeEl);
  return el;
}
